// destinoAposEntrar.js — para onde a pessoa vai depois de entrar ou se cadastrar.
//
// As duas telas de entrada (/login e /criar-conta) tinham a MESMA linha escrita
// à mão, e ela só sabia voltar para uma rota. Desde 15/09/2026 a navbar desvia
// para o login quem clica em E-books, Minha lista, Carrinho ou Créditos sem ter
// conta (ver Header.js) — e três desses quatro destinos não são uma rota, são
// uma ABA do perfil, que se abre por evento e não pela URL.
//
// Por isso o estado carrega duas coisas:
//   `de`  ... a rota para onde voltar (padrão: o perfil)
//   `aba` ... a aba do perfil a abrir quando chegar lá
//
// Sem o `aba`, quem clicasse em "Minha lista" sem conta entrava e era largado
// no perfil genérico, tendo de procurar de novo onde estava indo. Mandar alguém
// para o login já é um pedido a mais; fazê-la se reorientar depois seria o
// segundo.
//
// Os 150ms são os mesmos do Header: dão tempo de o Perfil montar e registrar o
// ouvinte antes de o evento ser disparado.
import { useLocation, useNavigate } from "react-router-dom";

const main = process.env.REACT_APP_MAIN;

const useDestinoAposEntrar = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  return () => {
    navigate(state?.de || main + "perfil", { replace: true });
    if (state?.aba) {
      setTimeout(
        () => window.dispatchEvent(new CustomEvent("changePerfiltab", { detail: state.aba })),
        150
      );
    }
  };
};

export default useDestinoAposEntrar;
